import type { IPublicClientApplication } from '@azure/msal-browser'
import { useMsal } from '@azure/msal-react'
import { CompoundButton, makeStyles } from '@fluentui/react-components'
import { GuestRegular } from '@fluentui/react-icons'

import { loginRequest } from '../config/authConfig.ts'

const useStyles = makeStyles({
  loginContainer: {
    display: 'flex',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
})

export default function Login() {
  const classes = useStyles()
  const { instance } = useMsal()

  const handleLogin = (instance: IPublicClientApplication) => {
    instance.loginRedirect(loginRequest).catch((e: unknown) => {
      console.error(e)
    })
  }

  return (
    <div className={classes.loginContainer}>
      <CompoundButton
        size="large"
        appearance="primary"
        icon={<GuestRegular />}
        onClick={() => {
          handleLogin(instance)
        }}
      >
        Please click here to sign in with SSO
      </CompoundButton>
    </div>
  )
}
